<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$helpers.getUplineName($store.getters.getSelectedType-1) + " " + $t("ui.list")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.account_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="account_id"
                    :placeholder='$t("ui.account_id")'
                    v-model="account_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row.mb-2
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-breadcrumb.bg-grey-transparent-2.p-l-10
                  b-breadcrumb-item(
                    v-for="(item,index) in items"
                    :key="index"
                    :text="item.account_id.toUpperCase()"
                    :class="{ active: index==items.length-1 }"
                    :title="$helpers.getUplineName(item.account_type)"
                    @click="redirectTo(item)"
                  )
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="agentList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged" :tbody-tr-class="rowClass")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    .d-flex
                      template(v-if="row.item.account_type != 1")
                        b-link(@click="redirectTo(row.item, 'viewDownline')") #[b {{ row.item.account_id.toUpperCase() }}]
                      template(v-else)
                        span #[b {{ row.item.account_id.toUpperCase() }}]
                  template(v-slot:cell(balance)="row")
                    span(v-if="!$helpers.isMemberLevel(row.item.account_type)" :class="$helpers.getNumberClass(row.item.cash_balance)") {{ row.item.cash_balance | currency }}
                    span(v-if="$helpers.isMemberLevel(row.item.account_type)" :class="$helpers.getNumberClass(row.item.game_balance)") {{ row.item.game_balance | currency }}
                  template(v-slot:cell(created_date)="row")
                    span {{ $moment(row.item.created_date).format("YYYY-MM-DD HH:mm:ss") }}

</template>

<script>
import SubmitButton from "@/library/SubmitButton"
// import currency from "@/components/settings/currency.vue"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    // currency,
    DebounceInput
  },
  data() {
    return {
      account_id: "",
      agentList: [],
      items: [],
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      filter: null,
      sortBy: "account_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0
    }
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          // sortable: true,
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "login_id",
          label: this.$t("ui.login_id"),
          // sortable: true,
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "full_name",
          label: this.$t("ui.full_name"),
          // sortable: true,
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "contact_phone",
          label: this.$t("ui.contact_phone"),
          // sortable: true,
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "8%"
          }
        },
        {
          key: "balance",
          label: this.$t("ui.balance"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "last_login_ip",
          label: this.$t("ui.login_ip"),
          // sortable: true,
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "created_date",
          label: this.$t("ui.created_on"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function(){
    this.submit()
  },
  methods: {
    searchFrom: function(account) {
      this.$store.dispatch("user/setSelectedID", account.account_id)
      this.$router.push("/search").catch(err=>{})
    },
    rowClass(item, type) {
      if (!item) return
      if (item.status === 'SUSPEND') return 'table-warning'
    },
    redirectTo: function(account, page) {
      this.$store.dispatch("user/setSelectedID", account.account_id)
      this.$store.dispatch("user/setSelectedType", account.account_type)
      if(account.account_id == this.$store.getters.accountID) {
        this.$router.push("/accountList")
      } else {
        this.submit()
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable()
    },
    refreshTable() {
      this.$root.$emit("bv::table::refresh", "tblList")
    },
    updateStatus: function(account, eventStatus) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.change_user_status_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let account_id = account.account_id
          let status = eventStatus.srcElement.value
          this.loading = true
          this.$store
            .dispatch("user/updateStatus", { account_id, status })
            .then(response => {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
              if (this.submission.success == true) {
                this.$swal(this.$t("ui.status"), this.$t("message.success"), "success")
                this.submit()
              } else {
                eventStatus.srcElement.value = account.status
              }
            })
            .catch(response => {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
              eventStatus.srcElement.value = account.status
            });
        } else {
          this.loading = false
          eventStatus.srcElement.value = account.status
        }
      });
    },
    submit: function() {
      if(this.$store.getters.getSelectedType == 2) {
        this.getMemberList()
      } else {
        this.getDownlineList()
      }
    },
    getDownlineList: function() {
      if (!this.$v.$invalid) {
        let search_id = this.account_id
        let target_account_id = this.$store.getters.getSelectedID
        let start_date = "";//(this.dateRange[0] != null) ? ((this.dateRange[0] != "") ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
        let end_date = "";//(this.dateRange[1] != null) ? ((this.dateRange[1] != "") ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
        let page_number = this.currentPage;
        this.currentPage = parseInt(page_number);
        let page_size = this.perPage;
        // let sort_key = this.sortBy;
        // let sort_type = this.direction;
        // let account_status = this.status;
        let account_status = '';
        this.loading = true
        this.$store
        //   .dispatch("user/getAccountList", { search_id, target_account_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .dispatch("user/getAccountList", { search_id, target_account_id, start_date, end_date, page_number, page_size, account_status })
          .then(response => {
            this.loading = false
            this.submission.success = response.success;
            // this.submission.status = response.errorTag;
            if (this.submission.success == true) {
              this.items = []
              this.items = response.line
              this.agentList = response.data
              this.totalRows = response.data.length > 0 ? this.agentList[0]["totalrows"] : 0;
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
            this.$router.push("/accountList")
          });
      }
    },
    getMemberList: function() {
      if (!this.$v.$invalid) {
        let search_id = this.account_id
        let target_account_id = this.$store.getters.getSelectedID
        let start_date = "";//(this.dateRange[0] != null) ? ((this.dateRange[0] != "") ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
        let end_date = "";//(this.dateRange[1] != null) ? ((this.dateRange[1] != "") ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
        let page_number = this.currentPage;
        this.currentPage = parseInt(page_number);
        let page_size = this.perPage;
        // let sort_key = this.sortBy;
				// let sort_type = this.direction;
        // let account_status = this.status;
        let account_status = '';
        this.loading = true
        this.$store
          // .dispatch("user/getMemberList", { search_id, target_account_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .dispatch("user/getMemberList", { search_id, target_account_id, start_date, end_date, page_number, page_size, account_status })
          .then(response => {
            this.loading = false
            this.submission.success = response.success;
            // this.submission.status = response.errorTag;
            if (this.submission.success == true) {
              this.items = []
              this.items = response.line
              this.agentList = response.data
              this.totalRows = response.data.length > 0 ? this.agentList[0]["totalrows"] : 0
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    }
  }
}
</script>